import { render, staticRenderFns } from "./GoMobileWrapper.vue?vue&type=template&id=9c9d82e4&scoped=true&"
import script from "./GoMobileWrapper.vue?vue&type=script&lang=js&"
export * from "./GoMobileWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GoMobileWrapper.vue?vue&type=style&index=0&id=9c9d82e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9d82e4",
  null
  
)

export default component.exports